import { render, staticRenderFns } from "./PreviewTourn.vue?vue&type=template&id=0960a6a1&"
import script from "./PreviewTourn.vue?vue&type=script&lang=js&"
export * from "./PreviewTourn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports